import { Trans } from 'react-i18next';
import React from 'react';
import { toast } from 'react-toastify';

import ModelService from './model.service';
import api from './api.service';

const VideoService = new ModelService('/videos', '/videos', 'animations');

VideoService.getImage = (filename, w = false, h = false, c = false) => VideoService.getFilePathByDir('/uploads/companies', filename, w, h, c);
VideoService.getImage2 = (filename, w = false, h = false, c = false) => VideoService.getFilePathByDir('/files', filename, w, h, c);

VideoService.VIDEO_STATUS_NEW = 1;
VideoService.VIDEO_STATUS_IN_PROGRESS = 2;
VideoService.VIDEO_STATUS_DONE = 3;
VideoService.VIDEO_STATUS_ERROR = 4;

VideoService.getStatusList = () => ({
  [VideoService.VIDEO_STATUS_NEW]: (<Trans>New</Trans>),
  [VideoService.VIDEO_STATUS_IN_PROGRESS]: (<Trans>In progress</Trans>),
  [VideoService.VIDEO_STATUS_DONE]: (<Trans>Done</Trans>),
  [VideoService.VIDEO_STATUS_ERROR]: (<Trans>Error</Trans>),
});

VideoService.getStatusOptions = t => VideoService
  .prepareOptionsFromSimpleObject(VideoService.getStatusList(t), true);

VideoService.getStatusTitle = (status, t) => {
  const label = VideoService.getStatusList(t)[status];
  return label || '-';
};

VideoService.getColorByStatus = (status) => {
  switch (status) {
    case VideoService.VIDEO_STATUS_NEW:
      return 'primary';
    case VideoService.VIDEO_STATUS_IN_PROGRESS:
      return 'warning';
    case VideoService.VIDEO_STATUS_DONE:
      return 'success';
    case VideoService.VIDEO_STATUS_ERROR:
      return 'danger';
    default:
      return 'secondary';
  }
};

VideoService.VIDEO_TYPE_DRAFT = 0;
VideoService.VIDEO_TYPE_VIDEO_MP4 = 1;
VideoService.VIDEO_TYPE_GIF = 2;
VideoService.VIDEO_TYPE_HTML5 = 3;
VideoService.VIDEO_TYPE_FRAMES_IMAGES = 4;
VideoService.VIDEO_TYPE_FRAME = 5;
VideoService.VIDEO_TYPE_VIDEO_MOV = 6;
VideoService.VIDEO_TYPE_KEY_FRAMES = 7;
VideoService.VIDEO_TYPE_KEY_FRAMES_GIF = 8;
VideoService.VIDEO_TYPE_TEMPLATES = 9;
VideoService.VIDEO_TYPE_HTML5_BANNER = 10;
VideoService.VIDEO_TYPE_HTML5_ADFORM = 11;
VideoService.VIDEO_TYPE_KEY_FRAMES_PDF = 12;

VideoService.getTypeList = () => ({
  [VideoService.VIDEO_TYPE_DRAFT]: 'Draft',
  [VideoService.VIDEO_TYPE_VIDEO_MP4]: 'MP4',
  [VideoService.VIDEO_TYPE_GIF]: 'GIF',
  [VideoService.VIDEO_TYPE_HTML5]: 'HTML5',
  [VideoService.VIDEO_TYPE_FRAMES_IMAGES]: 'Frames images',
  [VideoService.VIDEO_TYPE_FRAME]: 'Frame',
  [VideoService.VIDEO_TYPE_VIDEO_MOV]: 'MOV',
  [VideoService.VIDEO_TYPE_KEY_FRAMES]: 'Key frames',
  [VideoService.VIDEO_TYPE_KEY_FRAMES_GIF]: 'Frames GIF',
  [VideoService.VIDEO_TYPE_TEMPLATES]: 'Templates',
  [VideoService.VIDEO_TYPE_HTML5_BANNER]: 'Banner',
  [VideoService.VIDEO_TYPE_HTML5_ADFORM]: 'Addform',
  [VideoService.VIDEO_TYPE_KEY_FRAMES_PDF]: 'PDF',
});

VideoService.getTypeNameById = (videoType) => {
  const all = VideoService.getTypeList();
  return all[videoType] || '-';
};

VideoService.getColorByType = (status) => {
  switch (status) {
    case VideoService.VIDEO_TYPE_DRAFT:
      return 'secondary';
    case VideoService.VIDEO_TYPE_VIDEO_MP4:
    case VideoService.VIDEO_TYPE_VIDEO_MOV:
      return 'danger';
    case VideoService.VIDEO_TYPE_HTML5:
    case VideoService.VIDEO_TYPE_TEMPLATES:
    case VideoService.VIDEO_TYPE_HTML5_BANNER:
    case VideoService.VIDEO_TYPE_HTML5_ADFORM:
      return 'success';
    case VideoService.VIDEO_TYPE_FRAME:
    case VideoService.VIDEO_TYPE_KEY_FRAMES:
    case VideoService.VIDEO_TYPE_KEY_FRAMES_GIF:
    case VideoService.VIDEO_TYPE_KEY_FRAMES_PDF:
      return 'primary';
    case VideoService.VIDEO_TYPE_GIF:
      return 'info';
    default:
      return 'secondary';
  }
};

VideoService.getTypeOptions = t => VideoService
  .prepareOptionsFromSimpleObject(VideoService.getTypeList(t), true);

VideoService.getTypeTitle = (status, t) => {
  const label = VideoService.getTypeList(t)[status];
  return label || '-';
};

VideoService.render = async (modelId) => {
  return api.catchError(async () => {
    const url = `${VideoService.baseUrl}/${modelId}/rerender`;
    // alert(url);
    const { data } = await api.post(url);
    toast.warning(`Rendering start #${modelId}`);
    return url;
  });
};

export default VideoService;



// WEBPACK FOOTER //
// ./src/services/video.service.js